<template>
  <div>
    <!--弹出框-->
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" class="demo-ruleForm"
      style="height: 100%">
      <el-dialog title="淤地坝基本信息" :modal="false" :visible.sync="dialogVisible" v-dialogDrag :before-close="handleClose"
        :close-on-click-modal="false" :show-close="true" :close-on-press-escape="false">
        <el-row>
          <el-col :span="6">
            <el-form-item type="type" label="省" prop="ydbSheng">
              <el-input type="type" placeholder="省" class="from-el-input" v-model.trim="ruleForm.ydbSheng" :disabled="true">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="市" class="from-el-input-line" prop="ydbShi">
              <el-input type="type" placeholder="市" class="from-el-input" v-model.trim="ruleForm.ydbShi" :disabled="true">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="县" class="from-el-input-line" prop="ydbXian">
              <el-input type="type" placeholder="县" class="from-el-input" v-model.trim="ruleForm.ydbXian" :disabled="true">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="乡" class="from-el-input-line" prop="ydbXiang">
              <el-input type="type" placeholder="乡" class="from-el-input" v-model.trim="ruleForm.ydbXiang" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="村" class="from-el-input-line" prop="ydbCun">
              <el-input type="type" placeholder="村" class="from-el-input" v-model.trim="ruleForm.ydbCun" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="淤地坝名称" class="from-el-input-line" prop="ydbName">
              <el-input type="type" placeholder="淤地坝名称" class="from-el-input" v-model.trim="ruleForm.ydbName" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="淤地坝编码" class="from-el-input-line" prop="ydbCode">
              <el-input type="type" placeholder="淤地坝编码" class="from-el-input" v-model.trim="ruleForm.ydbCode" :disabled="true">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="淤地坝类型" class="from-el-input-line" prop="ydbSfwggb">
              <el-select v-model.trim="ruleForm.ydbSfwggb" placeholder="请选择类型" :disabled="nobj">
                <el-option label="大型坝" value="大型"></el-option>
                <el-option label="中型坝" value="中型"></el-option>
                <el-option label="小型坝" value="小型"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="枢纽组成" class="from-el-input-line" prop="ydbSnzc">
              <el-input type="type" placeholder="枢纽组成" class="from-el-input" v-model.trim="ruleForm.ydbSnzc" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="所在流域" class="from-el-input-line" prop="ydbSszl">
              <el-input type="type" placeholder="所在流域" class="from-el-input" v-model.trim="ruleForm.ydbSszl" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="建成年代" class="from-el-input-line" prop="ydbJcnd">
              <el-input type="type" placeholder="建成年代" class="from-el-input" v-model.trim="ruleForm.ydbJcnd" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="控制面积(km²)" class="from-el-input-line" prop="ydbKzmj">
              <el-input type="number" placeholder="控制面积(km²)" class="from-el-input" v-model.trim="ruleForm.ydbKzmj" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="坝高(m)" class="from-el-input-line" prop="ydbBaGao">
              <el-input type="number" placeholder="坝高(m)" class="from-el-input" v-model.trim="ruleForm.ydbBaGao" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="坝顶长(m)" class="from-el-input-line" prop="ydbBdcd">
              <el-input type="number" placeholder="坝顶长(m)" class="from-el-input" v-model.trim="ruleForm.ydbBdcd" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="总库容(万m³)" class="from-el-input-line" prop="ydbZkr">
              <el-input type="number" placeholder="总库容(万m³)" class="from-el-input" v-model.trim="ruleForm.ydbZkr" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="滞洪库容(万m³)" class="from-el-input-line" prop="ydbDhkr">
              <el-input type="number" placeholder="滞洪库容(万m³)" class="from-el-input" v-model.trim="ruleForm.ydbDhkr" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="设计淤积库容(万m³)" class="from-el-input-line" prop="ydbSjyjkr">
              <el-input type="number" placeholder="设计淤积库容(万m³)" class="from-el-input" v-model.trim="ruleForm.ydbSjyjkr" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="已淤库容(万m³)" class="from-el-input-line" prop="ydbYykr">
              <el-input type="number" placeholder="已淤库容(万m³)" class="from-el-input" v-model.trim="ruleForm.ydbYykr" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="设计淤地面积(hm²)" class="from-el-input-line" prop="ydbSjyjmj">
              <el-input type="number" placeholder="设计淤地面积(hm²)" class="from-el-input" v-model.trim="ruleForm.ydbSjyjmj" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="已淤地面积(hm²)" class="from-el-input-line" prop="ydbYyjmj">
              <el-input type="number" placeholder="已淤地面积(hm²)" class="from-el-input" v-model.trim="ruleForm.ydbYyjmj" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="经度" class="from-el-input-line" prop="ydbJingDu">
              <el-input type="number" placeholder="经度" class="from-el-input" v-model.trim="ruleForm.ydbJingDu" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="纬度" class="from-el-input-line" prop="ydbWeiDu">
              <el-input type="number" placeholder="纬度" class="from-el-input" v-model.trim="ruleForm.ydbWeiDu" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="是否改建" class="from-el-input-line" prop="ydbSfgj">
              <el-select v-model.trim="ruleForm.ydbSfgj" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="是否除险加固" class="from-el-input-line" prop="ydbSfcxjg">
              <el-select v-model.trim="ruleForm.ydbSfcxjg" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="是否老旧坝" class="from-el-input-line" prop="ydbSfljb">
              <el-select v-model.trim="ruleForm.ydbSfljb" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="病险数量统计" class="from-el-input-line" prop="ydbBxsltj">
              <!-- <el-select v-model.trim="ruleForm.ydbBxsltj" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select> -->
              <el-input type="number" placeholder="病险数量统计" class="from-el-input" v-model.trim="ruleForm.ydbBxsltj" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="是否需改造提升" class="from-el-input-line" prop="ydbSfxygzsj">
              <el-select v-model.trim="ruleForm.ydbSfxygzsj" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="是否需蓄水利用" class="from-el-input-line" prop="ydbSfxyxsly">
              <el-select v-model.trim="ruleForm.ydbSfxyxsly" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="是否被占用或改变用途" class="from-el-input-line" prop="ydbSfbzyhgbyt">
              <el-select v-model.trim="ruleForm.ydbSfbzyhgbyt" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="影响人数" class="from-el-input-line" prop="ydbYxrs">
              <el-input type="number" placeholder="影响人数" class="from-el-input" v-model.trim="ruleForm.ydbYxrs" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="重要设施" class="from-el-input-line" prop="ydbZyss">
              <el-input type="type" placeholder="重要设施" class="from-el-input" v-model.trim="ruleForm.ydbZyss" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="监控设施" class="from-el-input-line" prop="ydbJkss">
              <el-input type="type" placeholder="监控设施" class="from-el-input" v-model.trim="ruleForm.ydbJkss" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="管理责任主体" class="from-el-input-line" prop="ydbGlzrzt">
              <el-input type="type" placeholder="管理责任主体" class="from-el-input" v-model.trim="ruleForm.ydbGlzrzt" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="管护报酬" class="from-el-input-line" prop="ydbYwghbc">
              <el-input type="type" placeholder="管护报酬" class="from-el-input" v-model.trim="ruleForm.ydbYwghbc" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="其他问题" class="from-el-input-line" prop="ydbQtwtsm">
              <el-input type="type" placeholder="其他问题" class="from-el-input" v-model.trim="ruleForm.ydbQtwtsm" :disabled="nobj">
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">坝体病险情况</p>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="裂缝" class="from-el-input-line" prop="ydbBtlf">
              <el-select v-model.trim="ruleForm.ydbBtlf" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="滑坡坍塌" class="from-el-input-line" prop="ydbBthptt">
              <el-select v-model.trim="ruleForm.ydbBthptt" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="冲缺冲沟" class="from-el-input-line" prop="ydbBtcqcg">
              <el-select v-model.trim="ruleForm.ydbBtcqcg" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="管涌、渗漏" class="from-el-input-line" prop="ydbBtgysl">
              <el-select v-model.trim="ruleForm.ydbBtgysl" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">放水建筑物病险情况</p>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="卧管、竖井" class="from-el-input-line" prop="ybdFsjzwwgsj">
              <el-select v-model.trim="ruleForm.ybdFsjzwwgsj" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="涵洞、涵管" class="from-el-input-line" prop="ydbFsjzwhdhg">
              <el-select v-model.trim="ruleForm.ydbFsjzwhdhg" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="明渠" class="from-el-input-line" prop="ydbFsjzwmq">
              <el-select v-model.trim="ruleForm.ydbFsjzwmq" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">泄水建筑物病险情况</p>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="损毁" class="from-el-input-line" prop="ydbXsjzwmq">
              <el-select v-model.trim="ruleForm.ydbXsjzwmq" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="淘刷、悬空" class="from-el-input-line" prop="ydbXsjzwtsxk">
              <el-select v-model.trim="ruleForm.ydbXsjzwtsxk" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="其他" class="from-el-input-line" prop="ydbXsjzwqt">
              <el-select v-model.trim="ruleForm.ydbXsjzwqt" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <p style="text-align: center; color: #05699d;font-weight: bold;font-size: 16px;">其他安全隐患</p>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="道路不通" class="from-el-input-line" prop="ydbDlbt">
              <el-select v-model.trim="ruleForm.ydbDlbt" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item type="type" label="两岸边坡不稳定" class="from-el-input-line" prop="ydbLabpbwd">
              <el-select v-model.trim="ruleForm.ydbLabpbwd" placeholder="请选择是否" :disabled="nobj">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer" v-if="states=='bj'">
          <el-form-item>
            <el-button round @click="empty()" type="warning">取消</el-button>
            <el-button round type="primary" @click="deteRmine('ruleForm')">提交审核</el-button>
          </el-form-item>
        </span>
      </el-dialog>
    </el-form>
    <!--弹出框-->
  </div>
</template>

<script>
  import {
    submitRejectedYdb
  } from '@/api/api.js'
  export default {
    props: {
      mystate: Array
    },
    data() {
      return {
        dialogVisible: true,
        row: null,
        states: '',
        nobj: false,
        ruleForm: {
          id: '',
          userId: '',
          ydbSheng: '',
          ydbShengCode: '',
          ydbShi: '',
          ydbShiCode: '',
          ydbXian: '',
          ydbXianCode: '',
          ydbXiang: '',
          ydbCun: '',
          ydbName: '',
          ydbCode: '',
          ydbSfwggb: '',
          ydbSnzc: '',
          ydbSszl: '',
          ydbJcnd: '',
          ydbKzmj: '',
          ydbBaGao: '',
          ydbBdcd: '',
          ydbZkr: '',
          ydbDhkr: '',
          ydbSjyjkr: '',
          ydbYykr: '',
          ydbSjyjmj: '',
          ydbYyjmj: '',
          ydbJingDu: '',
          ydbWeiDu: '',
          ydbSfgj: '',
          ydbSfcxjg: '',
          ydbSfljb: '',
          ydbBxsltj: '',
          ydbSfxygzsj: '',
          ydbSfxyxsly: '',
          ydbSfbzyhgbyt: '',
          ydbYxrs: '',
          ydbZyss: '',
          ydbJkss: '',
          ydbGlzrzt: '',
          ydbYwghbc: '',
          ydbQtwtsm: '',
          ydbBtlf: '',
          ydbBthptt: '',
          ydbBtcqcg: '',
          ydbBtgysl: '',
          ybdFsjzwwgsj: '',
          ydbFsjzwhdhg: '',
          ydbFsjzwmq: '',
          ydbXsjzwmq: '',
          ydbXsjzwtsxk: '',
          ydbXsjzwqt: '',
          ydbDlbt: '',
          ydbLabpbwd: '',
          ydbLx: '',
        },
        rules: {
          ydbSheng: [{required: true,message: "请输入必填项",trigger: "blur"}],
          ydbShi: [{required: true,message: "请输入必填项",trigger: "blur"}],
          ydbXian: [{required: true,message: "请输入必填项",trigger: "blur"}],
          ydbXiang: [{required: true,message: "请输入必填项",trigger: "blur"}],
          ydbCun: [{required: true,message: "请输入必填项",trigger: "blur"}],
          ydbName: [{required: true,message: "请输入必填项",trigger: "blur"}],
          ydbCode: [{required: true,message: "请输入必填项",trigger: "blur"}],
          ydbSfwggb: [{required: true,message: "请输入必填项",trigger: "blur"}],
        },
      };
    },
    created() {
      //初始化数据
    },
    components: {},
    methods: {
      deteRmine(formName) {
        let _this = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let arr = [];
            arr.push(this.ruleForm);
            submitRejectedYdb(arr).then((res) => {
              if (res.code == 200) {
                this.$notify({
                  title: "提示",
                  message: "提交审核成功！",
                  type: "success",
                });
              } else {
                this.$notify({
                  title: "提示",
                  message: "提交审核失败！",
                  type: "error",
                });
              }
            });
            this.$emit('bjadddata', {
              dialogVisible: this.dialogVisible
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      empty() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          dialogVisible: this.dialogVisible
        });
      },
      handleClose() {
        this.dialogVisible = false;
        this.$emit("getcancel", {
          dialogVisible: this.dialogVisible
        });
      },
    },
    mounted() {
      this.row = this.mystate[1];
      this.states = this.mystate[0];
      //初始化
      if (this.states == 'ck') {
        this.nobj = true;
      }
      this.ruleForm.id = this.row.id;
      this.ruleForm.userId = this.row.userId;
      this.ruleForm.ydbLx = this.row.ydbLx;

      this.ruleForm.ydbSheng = this.row.ydbSheng;
      this.ruleForm.ydbShengCode = this.row.ydbShengCode;
      this.ruleForm.ydbShi = this.row.ydbShi;
      this.ruleForm.ydbShiCode = this.row.ydbShiCode;
      this.ruleForm.ydbXian = this.row.ydbXian;
      this.ruleForm.ydbXianCode = this.row.ydbXianCode;
      this.ruleForm.ydbXiang = this.row.ydbXiang;
      this.ruleForm.ydbCun = this.row.ydbCun;
      this.ruleForm.ydbName = this.row.ydbName;
      this.ruleForm.ydbCode = this.row.ydbCode;
      this.ruleForm.ydbSfwggb = this.row.ydbSfwggb;
      this.ruleForm.ydbSnzc = this.row.ydbSnzc;
      this.ruleForm.ydbSszl = this.row.ydbSszl;
      this.ruleForm.ydbJcnd = this.row.ydbJcnd;
      this.ruleForm.ydbKzmj = this.row.ydbKzmj;
      this.ruleForm.ydbBaGao = this.row.ydbBaGao;
      this.ruleForm.ydbBdcd = this.row.ydbBdcd;
      this.ruleForm.ydbZkr = this.row.ydbZkr;
      this.ruleForm.ydbDhkr = this.row.ydbDhkr;
      this.ruleForm.ydbSjyjkr = this.row.ydbSjyjkr;
      this.ruleForm.ydbYykr = this.row.ydbYykr;
      this.ruleForm.ydbSjyjmj = this.row.ydbSjyjmj;
      this.ruleForm.ydbYyjmj = this.row.ydbYyjmj;
      this.ruleForm.ydbJingDu = this.row.ydbJingDu;
      this.ruleForm.ydbWeiDu = this.row.ydbWeiDu;
      this.ruleForm.ydbSfgj = this.row.ydbSfgj;
      this.ruleForm.ydbSfcxjg = this.row.ydbSfcxjg;
      this.ruleForm.ydbSfljb = this.row.ydbSfljb;
      this.ruleForm.ydbBxsltj = this.row.ydbBxsltj;
      this.ruleForm.ydbSfxygzsj = this.row.ydbSfxygzsj;
      this.ruleForm.ydbSfxyxsly = this.row.ydbSfxyxsly;
      this.ruleForm.ydbSfbzyhgbyt = this.row.ydbSfbzyhgbyt;
      this.ruleForm.ydbYxrs = this.row.ydbYxrs;
      this.ruleForm.ydbZyss = this.row.ydbZyss;
      this.ruleForm.ydbJkss = this.row.ydbJkss;
      this.ruleForm.ydbGlzrzt = this.row.ydbGlzrzt;
      this.ruleForm.ydbYwghbc = this.row.ydbYwghbc;
      this.ruleForm.ydbQtwtsm = this.row.ydbQtwtsm;
      this.ruleForm.ydbBtlf = this.row.ydbBtlf;
      this.ruleForm.ydbBthptt = this.row.ydbBthptt;
      this.ruleForm.ydbBtcqcg = this.row.ydbBtcqcg;
      this.ruleForm.ydbBtgysl = this.row.ydbBtgysl;
      this.ruleForm.ybdFsjzwwgsj = this.row.ybdFsjzwwgsj;
      this.ruleForm.ydbFsjzwhdhg = this.row.ydbFsjzwhdhg;
      this.ruleForm.ydbFsjzwmq = this.row.ydbFsjzwmq;
      this.ruleForm.ydbXsjzwmq = this.row.ydbXsjzwmq;
      this.ruleForm.ydbXsjzwtsxk = this.row.ydbXsjzwtsxk;
      this.ruleForm.ydbXsjzwqt = this.row.ydbXsjzwqt;
      this.ruleForm.ydbDlbt = this.row.ydbDlbt;
      this.ruleForm.ydbLabpbwd = this.row.ydbLabpbwd;
    }
  };
</script>

<style scoped="scoped">
  >>>.el-dialog {
    width: 1400px;
  }

  >>>.el-dialog__body {
    max-height: 600px;
    overflow: auto;
  }

  >>>.el-form-item__error {
    padding-top: 0;
  }

  >>>.el-input__inner {
    padding-right: 0;
  }
</style>
